import { Divider, Grid, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useEffect, useState } from 'react';
import Cancel from '@mui/icons-material/Cancel';
import { useHistory, useParams } from 'react-router-dom';
import { customerService } from '../CustomerService';
import { CustomerV2 } from '../Model/CustomerModel';
import { Loader } from '../../../../Common/Components/Loader';
import {
  CardWrapper,
  FooterContainer,
  FooterWrapper,
  PaperWrapper,
} from '../../Common/CommonComponents';
import CustomButton from '../../../../Common/Components/Controls/InputControls';
import { showToast } from '../../../../lib/toast';

interface Param {
  customerId: string;
}

export default function RemoveCustomer() {
  const params = useParams<Param>();
  const initialState: CustomerV2 = {};
  const [customerData, getCustomer] = useState(initialState);
  const history = useHistory();
  const [loading, setLoading] = useState(true);

  const loadCustomerData = async () => {
    try {
      const customerData = await customerService.getCustomer(params.customerId);
      getCustomer(customerData);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = () => {
    setLoading(true);
    customerService.DeleteCustomer(params.customerId);
    showToast({
      type: 'success',
      title: 'runbook queued for removing customer...!',
    });
    setLoading(false);
    history.push('/customer');
  };

  const handleClose = () => {
    history.push('/customer');
  };

  useEffect(() => {
    loadCustomerData();
  }, []);
  return (
    <div>
      {loading ? (
        <Loader loading={loading} />
      ) : (
        <PaperWrapper>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Delete Customer
          </Typography>
          <Divider sx={{ mb: 3 }} />
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <CardWrapper>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Customer ID</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">{customerData.Id}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Customer</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      {customerData.Subdomain}
                    </Typography>
                  </Grid>
                </Grid>
              </CardWrapper>
            </Grid>
          </Grid>
          <FooterWrapper>
            <FooterContainer>
              <Grid item xs={12} sm="auto">
                <CustomButton
                  onClick={handleDelete}
                  startIcon={<DeleteIcon />}
                  label="Delete"
                />
                <CustomButton
                  onClick={handleClose}
                  startIcon={<Cancel />}
                  label="Cancel"
                />
              </Grid>
            </FooterContainer>
          </FooterWrapper>
        </PaperWrapper>
      )}
    </div>
  );
}
